<template>
  <picture
    class="picture"
    :style="{backgroundImage: `url(${user.avatar})`}"
  ></picture>
</template>

<script>
  export default {
    props: {
      user: { type: Object, required: true }
    }
  }
</script>

<style scoped lang="scss">
  .picture {
    display: block;
    width: 36px;
    height: 36px;
    background-size: cover;
    background-position: center center;
    border-radius: 100%;
    flex: 0 0 auto;
  }
</style>
